export const SET_COMPARE_DATA ='SET_COMPARE_DATA';
export const SET_COMPARE_RESULT ='SET_COMPARE_RESULT';
export const SET_FULL_SCREEN_INDEX ='SET_FULL_SCREEN_INDEX';
